import React, { useState } from 'react';
import { connect } from 'react-redux';
import MasterComponent from '../../../../../components/Forms';
import ShortListedConfig from '../../../../../entity/HRM/pre-onboarding/shortlistedConfig';
import { Button, Typography, Dropdown, Menu, Modal } from 'antd';
import { MasterConfigs } from '../../../../../interfaces/entity';
import { useDispatch } from 'react-redux';
import { putData } from '../../../../../actions/developer';
import DrawerComponent from '../../../../../components/Forms/Drawer';
import DoccumentReport from './doccumentReport';
import NextRoundModal from '../../tabs/Screening/modal';
import { constants } from '../../../../../constants/common';
import AddToBenchDeveloper from '../../../../../components/AddToBenchDeveloper/AddToBenchDeveloper';
import { EyeOutlined, EditOutlined, DeleteOutlined, MoreOutlined, UserAddOutlined } from '@ant-design/icons';
import FormSetup from '../../../../../components/Forms/FormSetup';
import { deleteRow } from '../../../../../actions/apiCall';

const { confirm } = Modal;

const VerifyDoccument = () => {
    const level = constants.PROFILE_STATUS.DOCCUMENT_VERIFY;
    const [candidateType, setCandidateType] = useState(null)
    const [visible, setVisible] = useState(false)
    const [id, setId] = useState(null)
    const dispatch = useDispatch();
    const [selected, setSelectedRow] = useState([])
    const [nextRound, setNextRound] = useState(false)
    const [formVisible, setFormVisible] = useState(false)
    const [isView, setIsView] = useState(false)
    const [formId, setFormId] = useState(null)
    const [addToBenchModal, setAddToBenchModal] = useState(false)
    const [selectedRecord, setSelectedRecord] = useState(null)

    const OverriddenConfig: MasterConfigs = {
        ...ShortListedConfig,
        api: () => ShortListedConfig.api() + '/' + level,
        isActionTab: true,
        tableProps: {
            rowSelection: {
                ...ShortListedConfig.rowSelection,
                onChange: (selectedRowKeys, selectedRows) => {
                    setSelectedRow(selectedRows)
                },
            },
        },
        actions: [...ShortListedConfig.actions, selected.length > 0 && { name: 'move to next', actionType: 'Add', onClick: () => onMoveToNext() }],
        getColumns: () => [
            ...ShortListedConfig.getColumns(),
            {
                title: 'Offerd CTC',
                key: '',
                dataIndex: '',
                width: 150,
                render: (text) => {
                    return <Typography.Title level={5} editable={{
                        onChange: (e) => onOfferedCTC(e, text),
                    }}>{text?.offeredCTC}</Typography.Title>
                }
            },
            {
                title: 'Uploaded Doccument',
                dataIndex: '',
                key: '',
                width: 150,
                render: (text) => {
                    return <Button onClick={() => confirmationlink(text)}>View</Button>
                },
            },
        ],
        customActionsItems: (record) => [
            {
                key: 'add-to-bench',
                icon: <UserAddOutlined />,
                label: 'Add to Bench',
                onClick: () => {
                    setSelectedRecord(record);
                    setAddToBenchModal(true);
                }
            }
        ],
        getFormColumns: () => [
            ...ShortListedConfig.getFormColumns().map(ele => {
                if (ele.name == 'candidateType') {
                    return {
                        ...ele,
                        selectProps: {
                            onChange: (text) => {
                                setCandidateType(text);
                            }
                        }
                    }
                } else {
                    if (ele.name == "experiance") {
                        if (candidateType == 'Experience') {
                            return ele
                        } else {
                            return
                        }
                    } else {
                        return ele
                    }
                }
            }).filter(Boolean)
        ]
    };

    const confirmationlink = async (item) => {
        setId(item._id);
        setVisible(true)
    }

    const onOfferedCTC = async (text, item) => {
        if (text != item.offeredCTC) {
            const resData = await dispatch(putData(ShortListedConfig.api() + '/' + level + '/' + item._id, { offeredCTC: text }));
            if (resData) {
                onRefresh()
            }
        }
    }

    const onRefresh = () => {
        dispatch({
            type: 'REFRESH_TABLE',
            refreshTable: true
        })
    }

    const onCancel = () => {
        setVisible(false)
    }

    const onMoveToNext = () => {
        setNextRound(true)
    }

    return <React.Fragment>
        <DrawerComponent
            title='Verify Doccuments'
            handleCancel={() => onCancel()}
            isView={true}
            loading={false}
            submitForm={() => { }}
            visible={visible}
        >
            <DoccumentReport id={id} />
        </DrawerComponent>
        <FormSetup
            config={OverriddenConfig}
            open={formVisible}
            onClose={() => {
                setFormVisible(false);
                setFormId(null);
            }}
            isModal={true}
            isView={isView}
            id={formId}
        />
        {selectedRecord && (
            <AddToBenchDeveloper
                record={selectedRecord}
                open={addToBenchModal}
                onClose={() => {
                    setAddToBenchModal(false);
                    setSelectedRecord(null);
                }}
                onSuccess={() => {
                    onRefresh();
                    setAddToBenchModal(false);
                    setSelectedRecord(null);
                }}
            />
        )}
        <NextRoundModal isVisible={nextRound} onClose={() => setNextRound(false)} selected={selected} level={level} />
        <MasterComponent config={OverriddenConfig} />
    </React.Fragment>
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.app.isAuthenticated,
    user: state.app.user,
});

export default connect(mapStateToProps)(VerifyDoccument);
